export type OcrAdminPreview = {
	front?: string | null;
	back?: string | null;
};

export type OcrAdminImages = {
	ocr_front?: string[];
	ocr_back?: string[];
	ocr_front_clear?: string[];
	ocr_back_clear?: string[];
	temporary?: string[];
	/** NIF-1027: última pareja coherente (back null si unique / sin reverso del intento). */
	ocr_preview?: OcrAdminPreview;
};

function nonEmptyUrl(url?: string | null): string | undefined {
	if (typeof url !== 'string') {
		return undefined;
	}
	const trimmed = url.trim();
	return trimmed !== '' ? trimmed : undefined;
}

/** URLs OCR para galería admin: primary + copia clara (SUPERADMIN) + temporary. */
export function collectOcrAdminImageUrls(imgs?: OcrAdminImages | null): string[] {
	if (!imgs) {
		return [];
	}
	return [
		...(imgs.ocr_front_clear ?? []),
		...(imgs.ocr_back_clear ?? []),
		...(imgs.ocr_front ?? []),
		...(imgs.ocr_back ?? []),
		...(imgs.temporary ?? []),
	].filter((url): url is string => Boolean(url));
}

/** Preview anverso: `ocr_preview.front` o fallback legacy clear/[0]. */
export function firstOcrFrontPreviewUrl(imgs?: OcrAdminImages | null): string | undefined {
	const fromPreview = nonEmptyUrl(imgs?.ocr_preview?.front);
	if (fromPreview) {
		return fromPreview;
	}
	return nonEmptyUrl(imgs?.ocr_front_clear?.[0]) ?? nonEmptyUrl(imgs?.ocr_front?.[0]);
}

/** Preview reverso: `ocr_preview.back` (null = no tile); fallback legacy solo si no hay ocr_preview. */
export function firstOcrBackPreviewUrl(imgs?: OcrAdminImages | null): string | undefined {
	if (imgs?.ocr_preview) {
		return nonEmptyUrl(imgs.ocr_preview.back);
	}
	return nonEmptyUrl(imgs?.ocr_back_clear?.[0]) ?? nonEmptyUrl(imgs?.ocr_back?.[0]);
}
